import { statuses, floorsList, paymentMethods, heightsList, units, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, alertDialog, noSelected, } from "i18n/ar.common";
export default {
    translation: {
        heightsList,
        main: {
            confirmationDialog: {
                accept: "قبول",
                cancel: "رفض",
            },
            controls: {
                top: {
                    projectList: "قائمة المشاريع",
                    statisticsButton: "عرض الإحصائيات", // I18N
                    layersButton: "طبقات",
                    layers: {
                        metro: "مترو",
                        places: "أماكن",
                        districts: "مناطق",
                        emirates: {
                            AE: "الإمارات",
                            default: "المناطق",
                        },
                    },
                },
                middle: {
                    errorAddProject: "لا يمكن وضع المشروع إلا داخل المنطقة.",
                    errorAddDistrict: {
                        AE: "لا يمكن وضع المنطقة إلا داخل الإمارة",
                        default: "لا يمكن وضع المنطقة إلا داخل المنطقة.",
                    },
                    addNewObject: "إضافة مشروع جديد",
                    adminWidget: {
                        project: "مشروع",
                        district: "منطقة",
                        emirate: {
                            AE: "إمارة",
                            default: "منطقة",
                        },
                        preLaunch: "قبل الإطلاق",
                    },
                },
                bottom: {
                    catalog: "كتالوج",
                },
            },
            metroStation: {
                line: "خط {{lineCode}}",
                plannedStation: "محطة مخطط لها",
                builtStation: "محطة قائمة",
                subtitle: "محطة مترو",
            },
            searchKeywords: {
                title: "كلمات مفتاحية للبحث",
                add: "إضافة",
                placeholder: "اكتب الاسم",
                tooltip: "الكلمات المستخدمة للعثور على المشروع في البحث",
            },
            projectEdit: {
                create: "إنشاء مشروع",
                edit: "تعديل المشروع",
                description: "الوصف",
                save: "حفظ",
                catalogPreview: "معاينة الكتالوج",
                deleteDialog: {
                    title: "حذف المشروع",
                    message: "هل من الممكن حقًا حذفه؟ \nلن يكون من الممكن استعادته، هذا كل شيء... أنهِ الأمر!",
                },
                closeDialog: {
                    title: "الخروج من تعديل المشروع؟",
                    message: "لم تحفظ التغييرات وجميع البيانات غير المحفوظة ستفقد",
                },
                tabs: {
                    information: "معلومات",
                    configurations: "التكوينات",
                    transactions: "المعاملات",
                    typicalUnits: "وحدات نموذجية",
                    units: "وحدات",
                    amenities: "وسائل الراحة",
                    paymentPlans: "خطط الدفع القديمة",
                    paymentPlansNew: "خطط الدفع الجديدة",
                    documentsAndVideos: "المستندات والفيديو",
                    "3d": "نماذج ثلاثية الأبعاد",
                },
                information: {
                    name: "الاسم",
                    namePlaceholder: "الاسم",
                    add: "إضافة",
                    description: "الوصف",
                    note: "ملاحظات المشروع {{symbols}}/{{maxSymbols}} رمزًا",
                    notePlaceholder: "الرجاء إدخال ملاحظتك",
                    developer: "مطور",
                    seller: "البائع",
                    developerPlaceholder: "غير محدد",
                    sellerPlaceholder: "غير محدد",
                    ownershipType: "نوع الملكية",
                    ownershipTypePlaceholder: "اختر",
                    postHandover: "بعد التسليم",
                    handover: "تسليم",
                    serviceCharge: {
                        TH: "صندوق التمويل/رسوم الصيانة",
                        default: "رسوم الخدمة",
                    },
                    minCommission: "العمولة من",
                    maxCommission: "العمولة إلى",
                    furnishing: "التأثيث",
                    startOfSales: "بدء المبيعات",
                    eoi: "إبداء الاهتمام",
                    eoiTitle: {
                        MX: "حجز",
                        default: "إبداء الاهتمام (EOI)",
                    },
                    eoiFrom: "من",
                    eoiTo: "إلى",
                    eoiAmount: "المبلغ",
                    eoiPercentage: "النسبة المئوية",
                    eoiHint: "أدخل كلا القيمتين لتحديد نطاق، أو قيمة واحدة للحد الأدنى أو الأقصى. إدخال نفس القيمة في الحقلين يحدد قيمة دقيقة.",
                    eoiNotProvided: "غير محدد",
                    eoiMinFrom: "يجب أن يكون حقل \u0022من\u0022 لإبداء الاهتمام أكبر من 0.",
                    eoiMinTo: "يجب أن يكون حقل \u0022إلى\u0022 لإبداء الاهتمام أكبر من 0.",
                    eoiRangeFrom: "يجب أن تكون أقل من أو تساوي {{max}}",
                    eoiRangeTo: "يجب أن تكون أكبر من أو تساوي {{min}}",
                    noc: "إعادة البيع مسموح بها بعد",
                    isPreLaunch: {
                        MX: "بيع مسبق",
                        default: "قبل الإطلاق",
                    },
                    preLaunchHint: {
                        MX: "الحجز وبدء المبيعات ينطبقان فقط على مشاريع البيع المسبق. إلغاء التحديد سيحذفهما معًا.",
                        default: "إبداء الاهتمام وبدء المبيعات ينطبقان فقط على مشاريع ما قبل الإطلاق. إلغاء التحديد سيحذفهما معًا.",
                    },
                    isPublished: "تم النشر",
                    isExclusive: "حصري",
                    hasUnitsOnRequest: "متاح عند الطلب",
                    save: "حفظ",
                    architecture: "الهندسة المعمارية",
                    interior: "الداخلية",
                    amenities: "وسائل الراحة",
                    projectLocation: "موقع المشروع (إحداثيات)",
                    projectLocationPlaceholder: "لصق الإحداثيات",
                    common: "عام",
                    has3DModel: "يوجد نموذج ثلاثي الأبعاد",
                    logoHint: "يستخدم شعار المطور/البائع افتراضيًا. يمكنك تحميل شعار مخصص إذا أردت.",
                    customLogo: "شعار مخصص",
                    logoReset: "إعادة تعيين",
                    logoSellerChangedNote: "لقد اخترت بائعًا مختلفًا. إذا لم تعد ترغب في شعار مخصص، يرجى إعادة تعيينه",
                    logoDeveloperChangedNote: "لقد اخترت مطورًا مختلفًا. إذا لم تعد ترغب في شعار مخصص، يرجى إعادة تعيينه",
                    addNewItems: {
                        title: "كلمات مفتاحية للبحث",
                        addText: "إضافة",
                        placeholder: "أدخل الاسم",
                        tooltip: "كلمات مفتاحية يمكن من خلالها العثور على المشروع في البحث.",
                    },
                },
                configurations: {
                    config: "تكوين",
                    add: "إضافة تكوين جديد",
                    deleteConfig: "حذف التكوين",
                    duplicate: "تكرار",
                    name: "اسم التكوين",
                    description: "وصف التكوين",
                    configType: "نوع التكوين",
                    configTypePlaceholder: "نوع التكوين",
                    attachConfig: "تكوين جديد",
                    updateConfig: "تكوين محدث",
                },
                transactions: {
                    title: "معرف DLD",
                    addText: "إضافة",
                    placeholder: "اكتب الرقم",
                    tooltip: "معرف DLD من السجل.",
                },
                paymentPlans: {
                    plan: "مخطط",
                    add: "إضافة مخطط جديد",
                    postHandover: "بعد التسليم",
                    deletePlan: "حذف المخطط",
                    duplicate: "تكرار",
                    duplicateToOther: "تكرار إلى مشروع آخر",
                    name: "اسم المخطط",
                    description: "وصف المخطط",
                    downPayment: "دفعة أولى",
                    underConstruction: "إجمالي المدفوعات بنهاية البناء",
                    underConstructionPlaceholder: "من 0٪ إلى 100٪",
                    stepName: "اسم خطوة الدفع",
                    stepDescription: "وصف خطوة الدفع",
                    save: "حفظ",
                    ...paymentMethods,
                    duplicateModal: {
                        title: "تكرار خطة الدفع",
                        message: "اختر الوجهة للصق نسخة خطة الدفع",
                        apply: "تطبيق",
                        inputPlaceholder: "اختر المشاريع",
                        dropdownInputPlaceholder: "بحث",
                    },
                    successModal: {
                        title: "تم التكرار بنجاح",
                        text: "تم تكرار {{planName}} بنجاح في المشاريع التالية:",
                        ok: "موافق",
                    },
                    errorModal: {
                        title: "خطأ",
                        ok: "موافق",
                    },
                },
                paymentPlansNew: {
                    methods: {
                        title: "طرق الدفع",
                        credit_debit_card: "بطاقة",
                        cash: "نقدي",
                        crypto: "عملة رقمية",
                        bank_check: "شيك رئيسي",
                        bank_transfer: "تحويل بنكي",
                    },
                    plans: {
                        title: "خطط الدفع",
                        addPlan: "خطة دفع جديدة",
                        planItem: {
                            defaultName: "خطط الدفع",
                            hasPostHandover: "يوجد بعد التسليم",
                            noPostHandover: "لا يوجد بعد التسليم",
                            duplicate: "تكرار",
                            duplicateToOther: "تكرار إلى مشروع آخر",
                            delete: "حذف المخطط",
                            about: "حول الخطة",
                            switchLabel: "تم النشر",
                            titleEN: "اسم الخطة بالإنجليزية",
                            titleRU: "اسم الخطة بالروسية",
                            placeholderEN: "اسم الخطة",
                            placeholderRU: "اسم الخطة",
                            emptyFieldErr: "لا يمكن أن يكون الحقل فارغًا",
                            toastWarning: "لا يمكن نسخ خطة دفع غير محفوظة، احفظها وحاول مرة أخرى!",
                            stage: {
                                addPayment: "إضافة خطوة جديدة",
                                about: "حول الدفع",
                                when: "متى",
                                amount: "المبلغ",
                                apply: "تطبيق",
                                titleEN: "العنوان بالإنجليزية",
                                titleRU: "العنوان بالروسية",
                                placeholderEN: "اسم الخطوة",
                                placeholderRU: "اسم الخطوة",
                                typeOfPayment: "نوع الدفع",
                                trigger: "مشغل",
                                switchRepeatPayments: "دفع متكرر",
                                refundable: "قابل للاسترداد",
                                value: "القيمة",
                                typeAmount: "أدخل المبلغ",
                                intervalType: "نوع الفاصل الزمني",
                                amountOfInterval: "قيمة الفاصل",
                                dateOfPayment: "تاريخ الدفع",
                                constructionProgress: "تقدم البناء",
                                repeatCount: "كم مرة",
                                interval: "التكرار",
                                frequency: "الفترة",
                                dropdownEdit: "تعديل",
                                dropdownDuplicate: "تكرار",
                                dropdownDeleteStep: "حذف الخطوة",
                                ready: "جاهز",
                            },
                        },
                    },
                },
                amenities: {
                    save: "حفظ",
                },
                documents: {
                    add: "إضافة",
                    save: "حفظ",
                    videos: {
                        title: "فيديوهات المشروع",
                        documents: "المستندات",
                        add: "إضافة",
                        vimeoLink: "رابط Vimeo",
                        titleOfTheLink: "عنوان الرابط",
                        maxReached: "الحد الأقصى 100 فيديو. احذف واحدًا قبل إضافة آخر.",
                    },
                },
                units: {
                    search: "بحث الوحدات",
                    addTypical: "إضافة وحدة نموذجية جديدة",
                    download: "تنزيل الوحدات",
                    uploadPlans: "رفع المخططات",
                    updateRealUnitsCheckDateButton: "تحديث تاريخ آخر تحديث إلى اليوم",
                    clearProjectStatisticButton: "مسح الإحصائيات",
                    deleteSoldOutUnitButton: "حذف وحدة مباعة",
                    updateTypicalUnitsDateTooltip: "تحديث تاريخ آخر تحديث إلى التاريخ الحالي",
                    notFilled: "غير مملوء",
                    plan: "مخطط",
                    number: "رقم",
                    type: "نوع",
                    layout: "تخطيط",
                    height: "ارتفاع",
                    floor: "طابق",
                    size: "الحجم",
                    square: "الحجم",
                    price: "السعر",
                    features: "ميزات",
                    view: "إطلالة",
                    views: "إطلالة",
                    action: "إجراء",
                    from: "من",
                    to: "إلى",
                    soldOut: "مباع",
                    soldOutShow: "إظهار المباع",
                    soldOutHide: "إخفاء المباع",
                    save: "حفظ",
                    heightsList,
                    ...units,
                    unitEdit: {
                        selectLayout: "اختر التخطيط",
                        layoutName: "اسم التخطيط",
                        search: "بحث",
                        unitsList: "قائمة الوحدات",
                        type: "نوع",
                        layout: "تخطيط",
                        height: "ارتفاع",
                        features: "ميزات",
                        floor: "طابق",
                        number: "رقم",
                        square: "مساحة",
                        price: "السعر",
                        views: "مشاهدات",
                        save: "حفظ",
                        apply: "تطبيق",
                        renderersShow: "جميع الوحدات",
                        renderersHide: "بدون تخطيطات",
                        uploadError: "لا يمكنك رفع أكثر من 10 ملفات في المرة الواحدة.",
                        deleteDialog: {
                            title: "حذف الوحدة",
                            message: 'هل أنت متأكد من حذف الوحدة؟ \nسيتم إزالتها بالكامل من النظام بعد حفظ المشروع! \n إذا كنت تريد وضع علامة "مباع" على الوحدة، فيرجى رفع ملف CSV جديد.',
                        },
                        noChanges: {
                            title: "لم يتم اكتشاف أي تغييرات في الملف",
                            footnote: "يرجى تحديثه قبل الإرسال.",
                        },
                    },
                    updateRealUnitsCheckDateDialog: {
                        title: "تحديث تاريخ آخر تحديث",
                        text: "هل أنت متأكد من تغيير التاريخ إلى اليوم؟",
                        successText: "اكتمل التحديث!",
                        failText: "فشل التحديث: {{json}}",
                        cancel: "إلغاء",
                        update: "تحديث",
                    },
                    clearStatisticDialog: {
                        title: "إحصائيات المشروع",
                        text: "هل أنت متأكد من مسح إحصائيات المشروع بالكامل؟",
                        successText: "تم مسح الإحصائيات بنجاح",
                        failText: "فشل المسح: {{json}}",
                        clear: "مسح",
                    },
                    updateTypicalUnitsCheckDateDialog: {
                        title: "تحديث تاريخ آخر تحديث",
                        text: "هل أنت متأكد من تغيير التاريخ إلى اليوم؟",
                        successText: "اكتمل التحديث!",
                        failText: "فشل التحديث: {{json}}",
                        cancel: "إلغاء",
                        update: "تحديث",
                    },
                    deleteAllPlansDialog: {
                        title: "إزالة جميع المخططات؟",
                        description: "هل أنت متأكد من إزالة المخططات من جميع الوحدات في هذا المشروع؟ (باستثناء وحدات إعادة البيع)",
                        tryAgainBtn: "حاول مرة أخرى",
                    },
                    deleteSelected: "حذف المحدد",
                    deleteSelectedUnitsDialog: {
                        title: "حذف الوحدات المحددة",
                        description: "هل أنت متأكد من حذف الوحدات المحددة؟",
                        cancel: "إلغاء",
                        delete: "حذف",
                    },
                    deleteSoldOutUnitDialog: {
                        title: "حذف وحدة مباعة",
                        text: "اكتب رقم الوحدة لحذفها",
                        inputPlaceholder: "رقم الوحدة",
                        deleteButton: "حذف",
                        successText: "تم حذف الوحدة بنجاح",
                        failText: "فشل الحذف: {{message}}",
                        ok: "موافق",
                    },
                    importSettingsModal: {
                        title: "تعيين عملة الاستيراد ووحدة المساحة",
                        projectLabel: "المشروع:",
                        noticeTitle: "إعدادات الاستيراد الدائمة",
                        noticeText: "سيتم تطبيق هذه الإعدادات على جميع وحدات البائع في Sunti Residence وجميع عمليات الاستيراد المستقبلية. سيتم تخزين الأسعار " +
                            "والمساحات تمامًا كما وردت في الملفات، دون تحويل. لا يمكن تغيير هذه الإعدادات لاحقًا في واجهة الإدارة.",
                        currencyPlaceholder: "اختر العملة",
                        currencyTitle: "العملة",
                        areaUnitPlaceholder: "اختر وحدة المساحة",
                        areaUnitTitle: "وحدة قياس المساحة",
                        cancel: "إلغاء الاستيراد",
                        submit: "تعيين الإعدادات والمتابعة",
                    },
                },
                amenitiesEditFailTitle: "خطأ في تحديث وسائل الراحة",
                models3d: {
                    add: "مبنى جديد",
                    units: "وحدات",
                    edit: "تعديل المبنى",
                    delete: "حذف المبنى",
                    published: "تم النشر",
                },
                catalogPreviewModal: {
                    title: "معاينة المشروع",
                    bodyText: "يفتح في علامة تبويب جديدة ويعرض كيف سيبدو المشروع في الكتالوج. تعكس المعاينة التغييرات المحفوظة فقط.",
                    openPreview: "فتح في علامة تبويب جديدة",
                    error: "خطأ",
                },
            },
            emirateEdit: {
                name: "الاسم",
                newEmirate: {
                    AE: "إمارة جديدة",
                    default: "منطقة جديدة",
                },
                aboutEmirate: {
                    AE: "عن الإمارة",
                    default: "عن المنطقة",
                },
                emirateName: {
                    AE: "اسم الإمارة",
                    default: "اسم المنطقة",
                },
                selectColor: "اختر اللون",
                deleteConfirmationModal: {
                    title: {
                        AE: "حذف الإمارة؟",
                        default: "حذف المنطقة؟",
                    },
                    description: {
                        AE: "هل أنت متأكد أنك تريد حذف الإمارة؟",
                        default: "هل أنت متأكد أنك تريد حذف المنطقة؟",
                    },
                },
                create: "إنشاء",
                save: "حفظ",
                location: "الموقع",
                add: "إضافة",
            },
            districtEdit: {
                createDistrict: "إنشاء منطقة",
                editDistrict: "تعديل المنطقة",
                newDistrict: 'منطقة جديدة', // I18N
                photos: 'صور', // I18N
                averagePrice: "متوسط السعر",
                aboutDistrict: 'عن المنطقة', // I18N
                districtName: 'اسم المنطقة', // I18N
                name: "الاسم",
                description: "الوصف",
                selectColor: 'اختر اللون', // I18N
                deleteConfirmationModal: {
                    title: "حذف المنطقة؟",
                    description: "هل أنت متأكد من حذف المنطقة؟",
                },
                deleteBlockedNotification: {
                    description: "المنطقة تحتوي على مشاريع. احذف المشاريع أولاً", // I18N
                },
                create: "إنشاء",
                save: "حفظ",
                addNewItems: {
                    title: 'كلمات مفتاحية للبحث',
                    addText: 'إضافة',
                    placeholder: 'أدخل الاسم',
                    tooltip: 'كلمات مفتاحية يمكن من خلالها العثور على المنطقة في البحث.',
                },
                location: 'الموقع', // I18N
                add: 'إضافة', // I18N
            },
            addNewItems: {
                title: 'كلمات مفتاحية للبحث',
                addText: 'إضافة',
                placeholder: 'أدخل الاسم',
                tooltip: 'كلمات مفتاحية يمكن من خلالها العثور على المنطقة في البحث.',
            },
            districtView: {
                description: "الوصف",
                descriptionHide: "إخفاء",
                descriptionShow: "إظهار",
                developers: "المطورون",
                places: "أماكن",
                projectsCount_one: "{{count}} مشروع",
                projectsCount_two: "{{count}} مشاريع",
                projectsCount_few: "{{count}} مشاريع",
                projectsCount_many: "{{count}} مشاريع",
                projectsCount_other: "{{count}} مشاريع",
                from: "من",
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                description: "الوصف",
                descriptionHide: "إخفاء",
                descriptionShow: "إظهار",
                floor: "طابق",
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: "السعر شامل العمولة",
                priceWithoutCommission: "السعر بدون عمولة",
                unitFeature: "ميزة الوحدة",
                unitView: "إطلالة من النافذة",
                currencyUpdatedDaily: "يتم التحديث يوميا",
                unitContactsAria: 'جهات اتصال بيع الوحدة', // I18N
                unitContactsModalTitle: "جهات اتصال",
                unitContactsModalOk: "موافق",
                fullUnitsList: "قائمة الوحدات الكاملة",
                addToCatalog: "مشروع إلى الكتالوج",
                unitsOnRequestHint: {
                    start: "بعض الوحدات من مخزون المطور متاحة عند طلب ",
                    link: "المدير",
                    end: ".",
                },
                unitsOnRequestBlockTitle: 'وحدات عند الطلب', // I18N
                unitsOnRequestBlockTitleSome: 'بعض وحدات المطور عند الطلب', // I18N
                unitsOnRequestBlockDescription: 'اتصل بالمدير للحصول على جميع التفاصيل حول الوحدات في هذا المشروع.', // I18N
                tabs: {
                    information: "معلومات",
                    amenities: "وسائل الراحة",
                    paymentPlans: "خطط الدفع",
                    units: "وحدات",
                    documentsAndVideos: "المستندات والفيديو",
                    seller: "البائع",
                    placesNearby: "أماكن قريبة",
                    transactions: 'المعاملات', // I18N
                },
                paymentMethods,
                information: {
                    developer: "مطور",
                    district: "منطقة",
                    price: "السعر",
                    pricePerSquare: "السعر لكل",
                    size: "الحجم",
                    postHandover: "بعد التسليم",
                    handover: {
                        title: "الاكتمال",
                        ready: "جاهز",
                    },
                    ownershipType: {
                        title: "نوع الملكية",
                        leasehold: "حق انتفاع",
                        freehold: "ملكية حرة",
                    },
                    unitType: "نوع الوحدة",
                    serviceCharge: {
                        TH: "صندوق التمويل/رسوم الصيانة",
                        default: "رسوم الخدمة",
                    },
                    furnishing: "التأثيث",
                    startOfSales: "بدء المبيعات",
                    eoi: {
                        title: {
                            MX: "حجز",
                            default: "إبداء الاهتمام (EOI)",
                        },
                        from: "من",
                        upTo: "حتى",
                        hint: {
                            MX: "يعتمد المبلغ النهائي للحجز على الوحدة المحددة وشروط البائع.",
                            default: "يعتمد المبلغ النهائي لإبداء الاهتمام على الوحدة المحددة وشروط البائع.",
                        },
                    },
                    noc: "إعادة البيع مسموح بها بعد",
                    projectConfigurations: "تكوينات المشروع",
                    managersContacts: "جهات اتصال المطور",
                    managersName: "الاسم",
                    managersPhone: "هاتف",
                    hide: "إخفاء",
                    show: "إظهار",
                    yes: "نعم",
                    no: "لا",
                },
                units: {
                    ...units,
                    from: "من",
                },
                paymentPlans: {
                    postHandover: "بعد التسليم",
                    noPostHandover: "لا يوجد بعد التسليم",
                    payment_one: "{{count}} دفعة",
                    payment_few: "{{count}} دفعات",
                    payment_many: "{{count}} دفعات",
                    payment_other: "{{count}} دفعات",
                    times_one: "({{count}} مرة كل {{intervalType}})",
                    times_few: "({{count}} مرات كل {{intervalType}})",
                    times_many: "({{count}} مرات كل {{intervalType}})",
                    times_other: "({{count}} مرات كل {{intervalType}})",
                    type_day_one: "{{count}} يوم",
                    type_day_few: "{{count}} أيام",
                    type_day_many: "{{count}} أيام",
                    type_day_other: "{{count}} أيام",
                    type_week_one: "{{count}} أسبوع",
                    type_week_few: "{{count}} أسابيع",
                    type_week_many: "{{count}} أسابيع",
                    type_week_other: "{{count}} أسابيع",
                    type_month_one: "{{count}} شهر",
                    type_month_few: "{{count}} أشهر",
                    type_month_many: "{{count}} أشهر",
                    type_month_other: "{{count}} أشهر",
                    type_year_one: "{{count}} سنة",
                    type_year_few: "{{count}} سنوات",
                    type_year_many: "{{count}} سنوات",
                    type_year_other: "{{count}} سنوات",
                    ready: "جاهز",
                },
                seller: {
                    salesManagers: "مديرو المبيعات",
                    salesManagersDescription: "جهات اتصال",
                    resaleContactsHint: "للتواصل بشأن وحدة إعادة البيع، يرجى الرجوع إلى بطاقة الوحدة.",
                    commission: "عمولة",
                    commissionDescription: "رسوم العمولة المطبقة",
                    commissionItemDescription: "نسبة الصفقات",
                    address: "موقع المكتب",
                    descriptionShow: "إظهار",
                    descriptionHide: "إخفاء",
                    clipboard: "تم النسخ!",
                },
                floorsList,
                heightsList,
                placesNearby: {
                    meters: "أمتار",
                },
                transactions: {
                    empty: {
                        header: 'لا توجد إحصائيات بعد',
                        subheader: 'نحن نعمل على هذا',
                        noData: 'لا توجد بيانات',
                        noDataChart: 'لا توجد بيانات. يرجى تغيير المرشحات لعرض الإحصائيات.',
                    },
                    tab: {
                        header: 'الإجمالي الكلي',
                        subheader: 'اضغط على الزر أدناه لعرض المعلومات التفصيلية.',
                        price: 'السعر الوسيط',
                        priceRatio: 'السعر الوسيط/{{square}}',
                        transactions: 'المعاملات',
                        modalButton: 'معلومات كاملة',
                    },
                    modal: {
                        table: {
                            saleType: 'نوع البيع',
                            type: 'النوع',
                            layouts: 'التخطيطات',
                            size: 'المساحة',
                            price: 'السعر',
                            salesDate: 'تاريخ البيع',
                            resale: 'إعادة بيع',
                            firstSale: 'البيع الأول',
                        },
                        filters: {
                            period: 'الفترة',
                            interval: 'الفاصل الزمني',
                            periodFilter: 'آخر سنة',
                            dateFrom: "من تاريخ",
                            dateTo: "إلى تاريخ",
                            selectLayout: 'جميع التخطيطات',
                            selectType: 'جميع الأنواع',
                            saleType: 'جميع أنواع البيع',
                            allTime: 'كل الوقت',
                            resale: 'إعادة بيع',
                            firstSale: 'البيع الأول',
                            filtersValues: {
                                periods: {
                                    'week': 'أسبوع',
                                    'month': 'شهر',
                                    '3months': '3 أشهر',
                                    '6months': '6 أشهر',
                                    'year': 'سنة',
                                    'allTime': 'كل الوقت',
                                    'range': 'اختيار تواريخ',
                                },
                                intervals: {
                                    'day': 'يوم',
                                    'week': 'أسبوع',
                                    'month': 'شهر',
                                    'quarter': 'ربع سنة',
                                    'year': 'سنة',
                                },
                                layouts: {
                                    'all': 'جميع التخطيطات',
                                    'Studio': 'استوديو',
                                    'Office': 'مكتب',
                                    'Retail': 'تجزئة',
                                    '1': 'غرفة نوم 1',
                                    '2': 'غرفتا نوم',
                                    '3': '3 غرف نوم',
                                    '4': '4 غرف نوم',
                                    '5': '5 غرف نوم',
                                    'PLUS_6': '6+ غرف نوم',
                                },
                                types: {
                                    'all': 'جميع الأنواع',
                                    '213': 'شقة',
                                    '215': 'فيلا',
                                    '217': 'قطعة أرض',
                                    '218': 'تجاري',
                                },
                                saleTypes: {
                                    'all': 'جميع أنواع البيع',
                                    '0': 'البيع الأول',
                                    '1': 'إعادة بيع',
                                },
                            },
                        },
                    },
                },
            },
            filters: {
                byLocation: {
                    title: "الموقع",
                    reset: "إعادة تعيين الموقع",
                },
                byCompany: {
                    title: "شركة",
                    reset: "إعادة تعيين الشركة",
                },
                other: {
                    title: "الفلاتر الرئيسية",
                    reset: "إعادة تعيين الفلاتر",
                },
            },
            fullUnitsList: {
                ...units,
                floorPlan: "مخطط",
                number: "رقم",
                type: "نوع",
                layout: "تخطيطات",
                unitHeight: "ارتفاع الوحدة",
                floor: "طابق",
                size: "الحجم",
                price: "السعر",
                view: "إطلالة",
                action: "إجراء",
                searchPlaceholder: "بحث الوحدات",
                pricePerSquare: "السعر لكل",
                priceWithCommission: "السعر شامل العمولة",
                priceWithoutCommission: "السعر بدون عمولة",
                distress: "بيع بخصم",
                floorsList,
                heightsList,
                unitsOnRequestHint: {
                    start: "بعض الوحدات من مخزون المطور متاحة عند طلب ",
                    link: "المدير",
                    end: ".",
                },
            },
            blockCompanyGap: {
                text_one: "{{count}} يوم متبقي حتى نهاية اشتراكك الحالي. لتمديد الوصول، اتصل بمديرك.",
                text_few: "{{count}} أيام متبقية حتى نهاية اشتراكك الحالي. لتمديد الوصول، اتصل بمديرك.",
                text_many: "{{count}} أيام متبقية حتى نهاية اشتراكك الحالي. لتمديد الوصول، اتصل بمديرك.",
                text_other: "{{count}} أيام متبقية حتى نهاية اشتراكك الحالي. لتمديد الوصول، اتصل بمديرك.",
            },
            statistics: {
                tooltipText: "منذ آخر تحديث",
                tooltipPreLaunchText: "سعر ما قبل الإطلاق",
                chartPreLaunchPointText: "قبل الإطلاق",
            },
            leftPanel: {
                project: "مشروع",
                district: "منطقة",
                emirate: 'إمارة', // I18N
                place: "مكان",
                filter: "فلاتر",
                "3D": "ثلاثي الأبعاد",
            },
        },
        personal: {
            companies: {
                title: "شركات",
                add: "إضافة شركة",
                tag_one: "{{count}} شركة",
                tag_few: "{{count}} شركات",
                tag_many: "{{count}} شركات",
                tag_other: "{{count}} شركات",
                broker: "وسيط",
                developer: "مطور",
                agency: 'وكالة', // I18N
                blocked: "محظور",
                active: "نشط",
                notAssigned: "غير معين",
                all: "الجميع",
                searchPlaceholder: "بحث",
                typePlaceholder: "نوع",
                contentManagerPlaceholder: "مدير محتوى",
                salesManagerPlaceholder: "مدير مبيعات",
                statusPlaceholder: "الحالة",
                titles: {
                    status: "الحالة",
                    logo: "شعار",
                    name: "الاسم",
                    type: "نوع",
                    employees: "موظفون",
                    blocking: "حظر",
                    contentManager: "محتوى",
                    salesManager: "مبيعات",
                    change: "تغيير",
                },
                editCompany: {
                    company: "شركة",
                    type: "نوع الشركة",
                    agent: "وكيل",
                    developer: "مطور",
                    basicInformation: {
                        title: "معلومات أساسية",
                        name: {
                            title: "اسم الشركة",
                            placeholder: "الاسم",
                        },
                        description: {
                            title: "الوصف {{chars}}/{{maxChars}}",
                            placeholder: "الحد الأقصى 500 حرف",
                        },
                        maxUsersCount: {
                            title: "الحد الأقصى لعدد المستخدمين",
                            placeholder: "حتى 100",
                        },
                        site: {
                            title: "الموقع الإلكتروني",
                            placeholder: "إدراج رابط",
                        },
                        address: {
                            broker: {
                                title: "عنوان الشركة",
                                placeholder: "إدراج عنوان",
                            },
                            developer: {
                                title: "عنوان مكتب المبيعات",
                                placeholder: "إدراج عنوان",
                            },
                        },
                    },
                    blocking: {
                        title: "حظر",
                        expiredAt: {
                            title: "تاريخ الحظر",
                            hint: "سيتم الحظر في الساعة 00:00 بتوقيت UTC في التاريخ المحدد",
                        },
                    },
                    resale: {
                        title: "الوصول إلى إعادة البيع",
                        maxUnits: {
                            title: "عدد وحدات إعادة البيع",
                            placeholder: "٠",
                        },
                    },
                    contacts: {
                        title: "جهات اتصال مكتب المبيعات",
                        name: {
                            title: "اسم المدير",
                            placeholder: "جون سميث",
                        },
                        phone: {
                            title: "هاتف",
                        },
                    },
                    responsible: {
                        title: "الموظفون المسؤولون",
                        searchPlaceholder: "بحث",
                        content: {
                            title: "مدير محتوى",
                            placeholder: "اختر مديرًا",
                        },
                        sales: {
                            title: "مدير مبيعات",
                            placeholder: "اختر مديرًا",
                        },
                    },
                    create: "إنشاء",
                    save: "حفظ",
                    analyticsMetrics: {
                        title: "الوصول إلى خدمة المقاييس",
                    },
                    addNewItems: {
                        title: 'كلمات مفتاحية للبحث',
                        addText: 'إضافة',
                        placeholder: 'أدخل الاسم',
                        tooltip: 'كلمات مفتاحية يمكن من خلالها العثور على المشروع في البحث.',
                    },
                    countries: {
                        title: 'الدول المتاحة',
                        placeholder: 'اختر الدول',
                    },
                    deleteDialog: {
                        title: "حذف الشركة؟", // I18N
                        text: "سيتم حذف الشركة وسيكون من الصعب استعادتها.", // I18N
                        cancel: "إلغاء",
                        confirm: "تأكيد",
                    },
                },
            },
            employees: {
                count_one: "{{count}} موظف",
                count_few: "{{count}} موظفين",
                count_many: "{{count}} موظفين",
                count_other: "{{count}} موظفين",
                createUser: "إنشاء مستخدم",
                inviteUser: "دعوة مستخدم",
                delete: "حذف",
                edit: "تعديل",
                changePassword: "تغيير كلمة المرور",
                companySelectionRequired: "يلزم اختيار الشركة",
                employees: "موظفون",
                requests: "الطلبات",
                reject: "رفض",
                approve: "موافقة",
                role: "الدور",
                userSearch: "بحث المستخدمين",
                editEmployee: {
                    broker: "مستخدم",
                    head_of_sales_department: "مسؤول",
                    admin: "المسؤول الأعلى",
                    additionalContacts: "جهات اتصال إضافية",
                    user: "مستخدم",
                    name: "الاسم",
                    namePlaceholder: "جون سميت",
                    email: "البريد الإلكتروني",
                    emailPlaceholder: "john@company.com",
                    phone: "هاتف",
                    password: "كلمة المرور",
                    role: "الدور",
                    create: "إنشاء",
                    edit: "تعديل",
                    add: "إضافة",
                    tg: "تيليغرام",
                    whatsapp: "واتساب",
                    instagram: "إنستغرام",
                    roles,
                    requiredField: "حقل الهاتف مطلوب.", // I18N
                    hint: "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل وتحتوي على حرف كبير وصغير ورقم ورمز.",
                    mainInfo: "المعلومات الرئيسية",
                    passwordInfo: "إنشاء كلمة مرور جديدة",
                },
                changeEmployeePassword: {
                    header: "تغيير كلمة المرور",
                    description: "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل وتحتوي على حرف كبير وصغير ورقم ورمز.",
                    uppercaseAndLowercaseLetterTitle: "يجب أن تحتوي كلمة المرور على حرف صغير وحرف كبير واحد على الأقل.",
                    oneDigitTitle: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
                    specialSymbolTitle: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
                    minimumLengthTitle: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل.",
                    newPasswordPlaceholder: "كلمة المرور الجديدة",
                    confirmedNewPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",
                    shortPasswordError: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
                    submitButton: "تعديل كلمة المرور",
                },
                roles: {
                    all: "الجميع",
                    broker: "مستخدم",
                    head_of_sales_department: "مسؤول",
                    admin: "المسؤول الأعلى",
                },
                inviteDropdown: {
                    share: "مشاركة رابط الدعوة",
                    downloadQR: "تنزيل رمز QR",
                    copyLink: "نسخ الرابط",
                    copyLinkSuccess: "تم نسخ الرابط",
                    refreshLink: "تحديث الرابط",
                },
                headers: {
                    photo: "صورة",
                    name: "الاسم",
                    role: "الدور",
                    email: "البريد الإلكتروني",
                    phone: "هاتف",
                    active: "نشط",
                    actions: "إجراءات",
                },
                approveConfirmation: {
                    header: "الموافقة على الطلب؟",
                    description: "هل أنت متأكد من الموافقة على الطلب من:\n{{name}}؟",
                    accept: "نعم",
                    cancel: "لا",
                },
                approveError: {
                    header: "حدث خطأ ما",
                    description: "حدث خطأ أثناء معالجة طلبك. يرجى الاتصال بالدعم",
                },
                rejectConfirmation: {
                    header: "رفض الطلب؟",
                    description: "هل أنت متأكد من رفض الطلب من:\n{{name}}؟",
                    accept: "نعم",
                    cancel: "لا",
                },
                createEmployeeDialog: {
                    title: "إنشاء مستخدم",
                    somethingWentWrong: "حدث خطأ ما",
                },
            },
            catalog: {
                catalog: "كتالوج",
                clear: "مسح",
                preview: "معاينة",
                settings: "الإعدادات",
                create: "إنشاء كتالوج",
                created: "تم إنشاء الكتالوج",
                createdError: {
                    title: "خطأ في إنشاء الكتالوج",
                    description: "يرجى المحاولة مرة أخرى أو حاول لاحقًا",
                },
                modal: {
                    title: "تحديد خيارات الدليل",
                    layoutImage: "مع التخطيطات",
                    layoutTable: "جدول",
                    darkTheme: "الوضع الداكن",
                    lightTheme: "الوضع الفاتح",
                    withMap: "موقع المشروع مع وصف المنطقة",
                    hideUnitsNumbers: "إخفاء أرقام الوحدات",
                    withDeveloper: "وصف المطور",
                    save: "حفظ",
                    cancel: "إلغاء",
                },
                empty: {
                    title: "كتالوجك فارغ",
                    description: "أضف مشاريع أو كائنات من الخريطة لبدء العمل مع كتالوجك",
                    button: "الذهاب إلى الخريطة",
                },
                project: "مشروع",
                number: "رقم",
                type: "نوع",
                layout: "تخطيط",
                height: "ارتفاع",
                floor: "طابق",
                size: "مساحة",
                pricePerSquare: "السعر لكل",
                price: "السعر",
                action: "إجراء",
                heightsList,
                ...floorsList,
                yes: "نعم",
                no: "لا",
                noDataTitle: "لا يوجد شيء في الكتالوج",
                noDataDescription: "أضف وحدات إلى الكتالوج عن طريق تحديدها على الخريطة",
            },
            files: {
                files: "ملفات",
                addFolder: "إضافة مجلد",
                addFile: "إضافة ملف",
            },
            menu: {
                profile: "ملفي الشخصي",
                places: "أماكن",
                amenities: "وسائل الراحة",
                companies: "شركات",
                employees: "موظفون",
                files: "ملفات",
                catalog: "كتالوج",
                resale: "إعادة بيع",
                toTheMap: "إلى الخريطة",
            },
            profile: {
                changePassword: "تغيير كلمة المرور",
                logout: "تسجيل الخروج",
                cancel: "إلغاء",
                save: "حفظ",
            },
            amenities: {
                title: "وسائل الراحة",
                actions: {
                    createAmenity: "إنشاء وسيلة راحة جديدة",
                    createType: "إنشاء نوع جديد",
                    loadAmenities: "تنزيل وسائل الراحة كملف CSV",
                    loadTypes: "تنزيل الأنواع كملف CSV",
                },
                filters: {
                    typeSearch: "بحث عن نوع",
                    amenitiesSearch: "بحث عن وسيلة راحة",
                    types: "أنواع",
                },
                empty: {
                    title: "لم يتم العثور على نتائج",
                    description: "حاول استخدام خيارات بحث مختلفة",
                    clean: "مسح",
                },
                list: {
                    title: "وسائل الراحة",
                    count_one: "{{count}} عنصر",
                    count_few: "{{count}} عناصر",
                    count_many: "{{count}} عناصر",
                    count_other: "{{count}} عناصر",
                    icon: "أيقونة",
                    name: "الاسم",
                    category: "الفئة",
                    edit: "تعديل",
                    editAmenity: "تعديل وسيلة الراحة",
                    deleteAmenity: "حذف وسيلة الراحة",
                    deleteDialog: {
                        title: "حذف وسيلة الراحة",
                        message: "هل أنت متأكد من حذف وسيلة الراحة؟",
                        cancel: "إلغاء",
                        delete: "حذف",
                    },
                },
                types: {
                    title: "أنواع",
                    count_one: "{{count}} فئة",
                    count_few: "{{count}} فئات",
                    count_many: "{{count}} فئات",
                    count_other: "{{count}} فئات",
                    icon: "أيقونة",
                    name: "الاسم",
                    amenitiesCount: "عدد وسائل الراحة",
                    edit: "تعديل",
                    editType: "تعديل النوع",
                    deleteType: "حذف النوع",
                    deleteDialog: {
                        title: "حذف النوع",
                        message: "هل أنت متأكد من حذف هذا النوع؟",
                        cancel: "إلغاء",
                        delete: "حذف",
                    },
                    deleteBlockedNotification: {
                        description: "لا يمكن حذف النوع لأنه يحتوي على وسائل راحة",
                    },
                },
                editTypeModal: {
                    editTitle: "تعديل النوع",
                    createTitle: "نوع جديد",
                    subtitle: "تأكد من أن اسم النوع فريد ولا يطابق أي اسم موجود.",
                    nameEnTitle: "اسم النوع بالإنجليزية",
                    nameRuTitle: "اسم النوع بالروسية",
                    namePlaceholder: "اسم النوع",
                    save: "حفظ",
                },
                editAmenityModal: {
                    editTitle: "تعديل وسيلة الراحة",
                    createTitle: "وسيلة راحة جديدة",
                    nameSectionTitle: "الاسم",
                    nameEnTitle: "اسم وسيلة الراحة بالإنجليزية",
                    nameRuTitle: "اسم وسيلة الراحة بالروسية",
                    namePlaceholder: "اسم وسيلة الراحة",
                    typeTitle: "النوع",
                    typePlaceholder: "بدون نوع",
                    save: "حفظ",
                },
            },
            places: {
                title: "أماكن",
                actions: {
                    createPlace: "إنشاء مكان جديد",
                    createType: "إنشاء نوع جديد",
                    loadPlaces: "تنزيل الأماكن كملف CSV",
                    loadTypes: "تنزيل الأنواع كملف CSV",
                },
                filters: {
                    typeSearch: "بحث عن نوع",
                    placesSearch: "بحث عن أماكن",
                    emirates: {
                        AE: "الإمارات",
                        default: "المناطق",
                    },
                    districts: "مناطق",
                    categories: "فئات",
                },
                list: {
                    title: "أماكن",
                    count_one: "{{count}} مكان",
                    count_few: "{{count}} أماكن",
                    count_many: "{{count}} أماكن",
                    count_other: "{{count}} أماكن",
                    icon: "أيقونة",
                    name: "الاسم",
                    edit: "تعديل",
                    emirates: {
                        AE: "الإمارات",
                        default: "المناطق",
                    },
                    districts: "مناطق",
                    categories: "فئات",
                    deleteDialog: {
                        title: "حذف المعلم",
                        message: "هل أنت متأكد من حذف المعلم؟",
                        cancel: "إلغاء",
                        delete: "حذف",
                    },
                    editPlace: "تعديل المكان",
                    deletePlace: "حذف المكان",
                },
                editTypeModal: {
                    subtitle: "تأكد من أن اسم الفريد ولا يتطابق مع أي اسم موجود.",
                    nameSectionTitle: "الاسم",
                    nameEnTitle: "اسم المعلم بالإنجليزية",
                    nameRuTitle: "اسم المعلم بالروسية",
                    namePlaceholder: "اسم المعلم",
                    importantLabel: "فئة مهمة",
                    editTitle: "تعديل النوع",
                    createTitle: "نوع جديد",
                    save: "حفظ",
                    hint: "تظهر الأماكن المهمة (المولات، المدارس، المتاحف) في أعلى القائمة؛ بينما تبقى الأماكن الأقل أهمية (مثل موقف الحافلات) في الأسفل.",
                },
                types: {
                    title: "أنواع",
                    count_one: "{{count}} نوع",
                    count_few: "{{count}} أنواع",
                    count_many: "{{count}} أنواع",
                    count_other: "{{count}} أنواع",
                    icon: "أيقونة",
                    name: "الاسم",
                    placesCount: "عدد الأماكن",
                    edit: "تعديل",
                    editType: "تعديل النوع",
                    deleteType: "حذف النوع",
                    deleteDialog: {
                        title: "حذف الفئة",
                        message: "أي أماكن تنتمي فقط إلى هذه الفئة ستظهر بدون فئة. فقط أضف فئة جديدة يدويًا إذا لزم الأمر.",
                        cancel: "إلغاء",
                        delete: "حذف",
                    },
                },
                editCreatePlaceModal: {
                    createTitle: "مكان جديد",
                    editTitle: 'تعديل المكان', // I18N
                    save: "حفظ",
                    locationSectionTitle: "الموقع",
                    locationPlaceholder: "لصق الموقع أو اضغط على الخريطة للتحديد",
                    nameSectionTitle: "الاسم",
                    namePlaceholder: "اسم المعلم",
                    descriptionSectionTitle: "الوصف",
                    descriptionPlaceholder: "الحد الأقصى 500 رمز",
                    categoriesSectionTitle: "فئات",
                    newCategory: "فئة جديدة",
                    categoriesPlaceholder: "بدون فئة",
                    photosSectionTitle: "صور",
                    uploadLabel: "رفع ملف",
                    categoriesDescription: "اختر الأيقونة التي ستكون مرئية للمستخدمين",
                    nameEnTitle: "اسم المعلم بالإنجليزية",
                    nameRuTitle: "اسم المعلم بالروسية",
                },
            },
            resale: {
                searchPlaceholder: "بحث الوحدات",
                add: "إضافة",
                statuses,
                status: "الحالة",
                project: "مشروع",
                number: "رقم",
                price: "السعر",
                square: "منطقة",
                floor: "طابق",
                type: "نوع",
                layout: "تخطيط",
                edit: "تعديل",
                district: "منطقة",
                assignee: "المكلف",
                sold_out: "مباع",
                downloadUnits: "تنزيل الوحدات",
                ...units,
                floorsList,
                addUnitModal: {
                    add: "إضافة وحدة",
                    edit: "تعديل الوحدة",
                    tabs: {
                        commonData: {
                            name: "بيانات عامة",
                            unitData: "بيانات الوحدة",
                            project: "مشروع",
                            projectPlaceholder: "اختر مشروعًا",
                            searchProjectInputPlaceholder: "اسم المشروع",
                            projectNoOptionsText: "إذا لم يكن المشروع الذي تريده في القائمة، فاتصل بالدعم عبر الدردشة.",
                            unitNumber: "رقم الوحدة",
                            unitNumberPlaceholder: "أدخل الرقم",
                        },
                        unitDetails: {
                            name: "تفاصيل الوحدة",
                            unitSpecification: "مواصفات الوحدة",
                            square: "المساحة بالقدم المربع",
                            squarePlaceholder: "٠ قدم²",
                            unitType: "نوع الوحدة",
                            unitTypePlaceholder: "اختر",
                            rooms: "تخطيط",
                            roomsPlaceholder: "اختر",
                            height: "ارتفاع",
                            heightPlaceholder: "اختر",
                            internalFloor: "الطابق التقريبي",
                            internalFloorPlaceholder: "اختر",
                            floor: "طابق",
                            floorPlaceholder: "رقم الطابق",
                            view: "إطلالة",
                            viewPlaceholder: "قائمة مفصولة بفواصل",
                            unitFeatures: "ميزات الوحدة",
                            unitFeaturesPlaceholder: "اختر ميزات الوحدة",
                            priceWithCommission: "السعر شامل العمولة",
                            price: "السعر بالدرهم الإماراتي",
                            pricePlaceholder: "٠ درهم",
                            documents: "مستندات",
                            documentTemplate: "نموذج التحقق من القائمة",
                            firstDocumentPlaceholder: "عقود / صك الملكية / اتفاقية شراء",
                            secondDocumentPlaceholder: "نموذج التحقق (العقد أ)",
                            duplicateFilesError: "يجب أن تكون الملفات مختلفة",
                            layouts: "تخطيطات",
                            layoutsPlaceholder: "اختر الصور",
                            attachLayoutsHint: "مطلوب رفع مخطط (مخططات) الوحدة. غير مسموح برفع صور المشروع أو صور أخرى.",
                            distress: "بيع بخصم",
                            distressHint: "بيع بخصم - يجب أن يكون سعر الوحدة أقل أو يساوي السعر الأصلي",
                            markAsDistress: "وضع علامة بيع بخصم",
                            floorsList,
                            heightsList,
                        },
                    },
                    button: {
                        next: "التالي",
                        create: "إنشاء",
                        toModeration: "إلى المراجعة",
                        save: "حفظ",
                    },
                    statuses: {
                        title: "الحالة",
                        ...statuses,
                    },
                },
                changeStatusUnitModal: {
                    status: "الحالة",
                    distress: "بيع بخصم",
                    project: "مشروع",
                    unitNumber: "رقم الوحدة",
                    square: "منطقة",
                    floor: "طابق",
                    unitType: "نوع الوحدة",
                    rooms: "عدد الغرف",
                    height: "ارتفاع",
                    price: "السعر",
                    firstDocument: "عقود / صك الملكية",
                    secondDocument: "نموذج التحقق",
                    layouts: "تخطيطات",
                    declineReason: "سبب الرفض",
                    deleteConfirmation: "هل أنت متأكد من حذف الوحدة؟",
                    soldOutConfirmation: "هل أنت متأكد من تغيير حالة الوحدة؟",
                    view: "إطلالة",
                    features: "ميزات الوحدة",
                    floorsList,
                    heightsList,
                    statuses,
                    buttons: {
                        decline: "رفض",
                        publish: "نشر",
                        delete: "حذف",
                        soldOut: "مباع",
                        unpublish: "إلغاء النشر",
                    },
                },
                declineReasonModal: {
                    header: "سبب الرفض",
                    close: "إغلاق",
                },
                unitsLimitReachedModal: {
                    header: "تم الوصول إلى الحد الأقصى",
                    text_one: "لقد وصلت إلى الحد الأقصى {{count}} وحدة. يرجى الاتصال بالمسؤول.",
                    text_few: "لقد وصلت إلى الحد الأقصى {{count}} وحدات. يرجى الاتصال بالمسؤول.",
                    text_many: "لقد وصلت إلى الحد الأقصى {{count}} وحدات. يرجى الاتصال بالمسؤول.",
                    text_other: "لقد وصلت إلى الحد الأقصى {{count}} وحدات. يرجى الاتصال بالمسؤول.",
                    close: "إغلاق",
                },
                downloadResaleUnitModal: {
                    title: "تنزيل الوحدات",
                    submit: "تنزيل ورقة Excel",
                    message: "اختر الخصائص التي تظهر في الورقة.",
                    successMessage: "تم تنزيل الجدول بنجاح! يرجى التحقق من صفحة التنزيلات في متصفحك.",
                    ok: "موافق",
                    columns: {
                        project: "مشروع",
                        price: "السعر درهم",
                        area: "المساحة قدم²",
                        districtName: "منطقة",
                        unitType: "نوع",
                        unitLevel: "طابق",
                        unitFeature: "ميزات الوحدة",
                        unitNumber: "رقم الوحدة",
                        unitStatus: "الحالة",
                        unitLayout: "تخطيط",
                        assignUserName: "المكلف",
                    },
                },
            },
        },
        login,
        resetPassword: {
            passwordReset: {
                header: "استعادة كلمة المرور",
                body: "أنشئ كلمة مرور جديدة. يجب أن تتكون من 8 أحرف على الأقل وتحتوي على حرف كبير وصغير ورقم ورمز.",
                uppercaseAndLowercaseLetterTitle: "يجب أن تحتوي كلمة المرور على حرف صغير وحرف كبير واحد على الأقل.",
                oneDigitTitle: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
                specialSymbolTitle: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
                minimumLengthTitle: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل.",
                password: "كلمة المرور الجديدة",
                passwordConfirmation: "تأكيد كلمة المرور الجديدة",
            },
            passwordSubmited: {
                header: "لديك الآن كلمة مرور جديدة!",
                body: "تم إنشاء كلمة المرور الجديدة بنجاح ويمكنك الآن استخدامها لتسجيل الدخول إلى Geniemap.",
            },
            createPassword: "حفظ كلمة المرور",
            ok: "موافق",
        },
        registration: {
            invalidLink: {
                title: "رابط غير صالح",
                description: "للأسف لقد حصلت على رابط غير صالح، يرجى مطالبة المسؤول بتزويدك برابط جديد",
            },
            title: "إنشاء حساب",
            description: "أكمل جميع الخطوات للتقدم بطلب للحصول على حساب GenieMap",
            step: "خطوة {{step}}/{{steps}}",
            continue: "متابعة",
            step1: {
                emailError: "عنوان البريد الإلكتروني غير صالح أو مستخدم بالفعل.",
            },
            step2: {
                firstName: "الاسم",
                lastName: "اسم العائلة",
                phone: "رقم الهاتف",
            },
            step3: {
                password: "كلمة المرور",
                passwordConfirmation: "تأكيد كلمة المرور",
                uppercaseAndLowercaseLetterTitle: "يجب أن تحتوي كلمة المرور على حرف صغير وحرف كبير واحد على الأقل.",
                oneDigitTitle: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.",
                specialSymbolTitle: "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.",
                minimumLengthTitle: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل.",
            },
            step4: {
                description: "لقد أرسلنا بريدًا إلكترونيًا للتحقق إلى صندوق الوارد الخاص بك. افتح البريد الإلكتروني وانقر على الرابط لتقديم طلبك.",
                button: "إعادة إرسال رابط التأكيد",
                counter_one: "يمكنك إعادة إرسال الرابط مرة أخرى خلال {{ count }} ثانية",
                counter_few: "يمكنك إعادة إرسال الرابط مرة أخرى خلال {{ count }} ثوانٍ",
                counter_many: "يمكنك إعادة إرسال الرابط مرة أخرى خلال {{ count }} ثوانٍ",
                counter_other: "يمكنك إعادة إرسال الرابط مرة أخرى خلال {{ count }} ثوانٍ",
            },
            emailVerified: {
                success: {
                    title: "تم إرسال الطلب",
                    subTitle: "تم تقديم طلبك بنجاح.",
                    description: "يرجى انتظار موافقة المسؤول على الطلب. سيتم إعلامك عبر البريد الإلكتروني.",
                },
                error: {
                    title: "رابط التحقق غير صالح",
                    subTitle: "رابط التحقق هذا إما منتهي الصلاحية أو غير صالح. يرجى طلب رابط جديد لإكمال التحقق من بريدك الإلكتروني.",
                },
            },
        },
        projectsList: {
            projects: "",
            projects_one: "{{ found }} من {{ count }} مشروع",
            projects_few: "{{ found }} من {{ count }} مشاريع",
            projects_many: "{{ found }} من {{ count }} مشاريع",
            projects_other: "{{ found }} من {{ count }} مشاريع",
            noResultsFound: "لم يتم العثور على نتائج",
            tryDifferentSearchOptions: "حاول استخدام خيارات بحث مختلفة",
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: "السعر من",
                handover: "تسليم",
            },
        },
        common: {
            header: {
                logout: "تسجيل الخروج",
                searchButton: "بحث",
                locationButton: "الموقع",
                companyButton: "شركة",
                mainFiltersButton: "الفلاتر الرئيسية",
                clearButton: "مسح",
                searchPlaceholder: "البحث باسم المشروع أو المطور",
            },
            uploadArea: {
                invalidFileType: "نوع ملف غير صالح.",
                invalidFileSize: "يجب ألا يتجاوز حجم الملف 5 ميغابايت",
                availableActions: "رفع أو لصق",
                add: "إضافة",
                upload: "رفع",
            },
            input: {
                noMatch: "لا يوجد تطابق",
            },
            uploadModal: {
                description: "الوصف",
                cancel: "إلغاء",
                save: "حفظ",
            },
            confirmModal: {
                cancel: "إلغاء",
                confirm: "تأكيد",
                ok: "موافق",
            },
            authError: "خطأ في التفويض",
            uploadPhoto: {
                wrongString: "تنسيق غير صالح لسلسلة الحد الأقصى لحجم العرض: {{renderMaxSize}}",
                wrongSize: "يجب ألا يزيد حجم الحقل عن 5 ميغابايت.",
            },
            select: {
                noSelected,
            },
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            measures,
            countries,
            autocomplete,
            alertDialog,
        },
        ws: {
            catalog: {
                start_catalog_generate: "بدأ الكتالوج في التوليد.",
                catalog_generated: "تم إنشاء الكتالوج بنجاح",
                warning: "تحذير",
            },
            auth: {
                logout: "تم تسجيل خروجك بسبب كثرة الاتصالات من حسابك.",
            },
        },
    },
};
